import React, { memo, useEffect, useState } from "react";
import {
  Button,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormControlLabel,
  Checkbox,
  Typography,
  Grid,
  InputAdornment,
  Divider,
  IconButton,
  RadioGroup,
  Radio,
} from "@mui/material";
import { motion } from "framer-motion";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ContactsIcon from "@mui/icons-material/Contacts";
import AlertDialog from "../../Components/AlertDialog/AlertDialog";
import { useDispatch, useSelector } from "react-redux";
import { triggerLoader } from "../../redux/reducers/LoaderTrigger";
import Constants from "../../utility/Constants";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import configServ from "../../services/config";
import CustomerContact from "../../Components/Customers/CustomerContact";
import { rSetShowFab } from "../../redux/reducers/GlobalVariables";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import BulkCustomerUploadDialog from "./BulkCustomerUploadDialog";
import Swal from "sweetalert2";
import LoaderBackdrop from "../../Components/Loader/LoaderBackdrop";

//FUNCTION
const CustomerCard = ({
  open,
  isChanged,
  setIsChanged,
  editData,
  setEditData,
}) => {
  //#region code
  const dispatch = useDispatch();
  // const app = useSelector((state) => state.GlobalVariables.noRoomService);
  // const { company_id } = useSelector((state) => state.GlobalVariables);
  const {
    user_id,
    company_id,
    companyCountry,
    companyState,
    is_super,
    is_admin,
    permissions,
  } = useSelector((state) => state.GlobalVariables);

  const initialFormData = {
    openingamount: 0,
    type: "Standard",
    country: companyCountry,
    State: "",
    status: true,
    send_mail: false,
    city: "",
    date_of_birth: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [isDone, setIsDone] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [openCustContact, setOpenCustContact] = useState(false);
  const [isCustomerName, setIsCustomerName] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [title, setTitle] = useState("Alert");
  const [dialogContent, setDialogContent] = useState("");
  const [buttonType, setButtonType] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [location, setLocation] = useState(null);
  const [cityName, setCityName] = useState(null);
  // const API_KEY = "c7b63df0236f41689513cba5bc288cf4"; // Replace with your API key
  const API_KEY = process.env.REACT_APP_API_KEY;
  const [runLocation, SetRunLocation] = useState(null);

  const handleOpenDialog = (heading, content, type) => {
    setTitle(heading);
    setDialogContent(content);
    setButtonType(type);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setTitle("Alert");
    setDialogContent("");
    setButtonType(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    //Update form data
    setFormData((state) => ({
      ...state,
      [name]: value,
    }));

    // Reset the validation error when the user starts typing
    if (validationErrors[name]) {
      setValidationErrors((prevValidationError) => ({
        ...prevValidationError,
        [name]: "",
      }));
    }
  };

  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    setFormData((state) => ({
      ...state,
      [name]: checked,
    }));
  };

  const assignContactName = () => {
    if (!isDone) {
      setFormData((state) => ({
        ...state,
        contact_name: formData.fname || "",
      }));
    }
  };

  const handleSubmit = async () => {
    try {
      dispatch(triggerLoader());
      const dataToSend = {
        ...formData,
        company_id: company_id,
        user_id: user_id,
        latitude: location?.latitude,
        longitude: location?.longitude,
      };
      if (Boolean(formData.is_credit_days) === false) {
        delete dataToSend.credit_period;
        delete dataToSend.credit_limit;
      }

      const error = await handleFormValidation();
      if (error === false) {
        return false;
      }
      setValidationErrors({});
      if (!isEdit) {
        const result = await configServ.addCustomer(dataToSend);
        if (result.status === 200) {
          setIsChanged(!isChanged);
          clear();
          handleOpenDialog(
            "Success",
            result.message || "Customer created successfully.",
            "success"
          );
        } else if (result.status === 409) {
          handleOpenDialog(
            "Warning",
            result.message || "Failed to add customer.",
            "warning"
          );
        } else if (result.status === 400) {
          handleOpenDialog(
            "Warning",
            result.message || "Failed to add customer.",
            "warning"
          );
        } else {
          handleOpenDialog("Error", "Failed to add customer.", "error");
        }
      } else {
        const result = await configServ.editCustomer(dataToSend);
        if (result.status === 200) {
          setIsChanged(!isChanged);
          clear();
          handleOpenDialog("Success", result.message, "success");
        } else if (result.status === 409) {
          handleOpenDialog(
            "Warning",
            result.message || "Failed to add customer.",
            "warning"
          );
        } else {
          handleOpenDialog("Error", "Failed to update customer.", "error");
        }
      }
    } catch (e) {
      console.log(e);
      handleOpenDialog("Error", "An unexpected error has occurred.", "error");
    } finally {
      dispatch(triggerLoader());
    }
  };

  const fetchCountries = async () => {
    try {
      const res = await configServ.getCountry();
      if (res.status === 200) {
        setCountryList(res.data);
      } else {
        setCountryList([]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (openDialog) fetchCountries();
  }, [openDialog]);

  useEffect(() => {
    if (formData.country && countryList.length > 0) {
      fetchStates();
    }
    // else {
    //   fetchCountries();
    // }
  }, [formData.country, countryList]);

  const fetchStates = async () => {
    try {
      const countryId = countryList.find(
        (x) => x.country === formData.country
      ).PK;
      const res = await configServ.getState({ country: countryId });
      if (res.status === 200) {
        setStateList(res.data);
      } else {
        setStateList([]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (editData !== null) {
      setFormData(editData);
      setIsEdit(true);
      setOpenDialog(true);
  
      if (editData.type === "GST Compliant") {
        setGstType("with_gstin");
      } else {
        setGstType("without_gstin");
      }
    }
  }, [editData]);
  

  

  const handleCustContactOpen = () => {
    setOpenCustContact(true);
  };
  const handleCustContactClose = () => {
    setOpenCustContact(false);
  };

  // Regular expression pattern for validating email addresses
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleFormValidation = async () => {
    const errors = {};
    if (!formData.fname) {
      errors.fname = "required";
    } else if (!isCustomerName && !isEdit) {
      errors.fname = "required";
    }
    if (!formData.contact_name) {
      errors.contact_name = "required";
    }
    // if (!formData.mobile) {
    //   errors.mobile = "required";
    // }
    if (formData.email) {
      if (!emailPattern.test(formData.email)) {
        errors.email = "Invalid Email";
      }
    }
    if (!formData.address) {
      errors.address = "required";
    }
    if (!formData.country) {
      errors.country = "required";
    }
    if (!formData.State) {
      errors.State = "required";
    }
    // if (!formData.Pin) {
    //   errors.Pin = "required";
    // }
    if (!formData.type) {
      errors.type = "required";
    }
    if (!formData.openingamount) {
      errors.openingamount = "required";
    }
    // ✅ PAN card validation (only if value is provided)
    if (formData.pan_no) {
      const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (!panPattern.test(formData.pan_no)) {
        errors.pan_no = "Invalid PAN number format";
      }
    }
    setValidationErrors(errors);
    return Object.values(errors).every((error) => error === "");
  };

  const handleClickOpen = () => {
    dispatch(rSetShowFab(openDialog)); // Dispatch action
    setOpenDialog(!openDialog);
    clear();
  };

  const checkCustomerName = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        fname: formData.fname,
      };
      const res = await configServ.checkCustomerName(dataToSend);
      if (res.status === 200) {
        setIsCustomerName(true);
      } else {
        setIsCustomerName(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (formData.fname) {
      checkCustomerName();
    } else {
      setIsCustomerName(false);
    }
  }, [formData.fname]);

  const getLocation = async () => {
    try {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setLocation({ latitude, longitude });
          },
          (error) => {
            console.log("Error getting location:", error);
          }
        );
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    } catch (e) {
      console.log(e);
    }
  };

  // Location detect karna
  useEffect(() => {
    if (runLocation) {
      getLocation();
    }
  }, [runLocation]);

  const fetchLocation = async () => {
    try {
      const { latitude, longitude } = location;
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${API_KEY}`
      );
      const data = await response.json();
      setCityName(data.name);
      setFormData((prevState) => ({
        ...prevState,
        city: data.name,
      }));
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (location) {
      fetchLocation();
    }
  }, [location, API_KEY]);

  const handleCut = () => {
    setOpenDialog(!openDialog);
    clear();
  };

  const [openn, setOpen] = useState(false);

  const handleBulkUpload = () => {
    setOpen(true);
  };
  const [loadderPan, setLoadderPan] = useState(false);

  const handlePanVerified = async () => {
    // Check if date_of_birth is missing
    // if (!formData.date_of_birth) {
    //   await Swal.fire({
    //     icon: "warning",
    //     title: "Missing Date of Birth",
    //     text: "Please update your date of birth first before verifying PAN.",
    //     confirmButtonText: "OK",
    //   });
    //   return;
    // }

    // Show verification modal
    const result = await Swal.fire({
      title: "PAN Card Verification",
      html: `
        <div style="text-align: left;">
          <label><b>Name:</b></label><br/>
          <input type="text" id="swal-name" class="swal2-input" value="${
            formData.fname || ""
          }" disabled /><br/>
          <label><b>Date of Birth:</b></label><br/>
          <input type="date" id="swal-dob" class="swal2-input" value="${
            formData.date_of_birth || ""
          }"  />
          <p style="color:red; margin-top:10px;">
            ⚠️ You cannot attempt verification more than 2 times.
          </p>
          <p style="color:orange; font-size: 14px;">
            ℹ️ Your name and date of birth must match with your PAN records. If not, please update them before proceeding.
          </p>
        </div>
      `,
      confirmButtonText: "Verify PAN",
      showCancelButton: true,
      preConfirm: () => {
        const name = document.getElementById("swal-name").value;
        const dob = document.getElementById("swal-dob").value;

        if (!name || !dob) {
          Swal.showValidationMessage(
            "Both name and date of birth are required."
          );
          return false;
        }

        return { name, dob };
      },
    });

    // If confirmed, proceed
    if (result.isConfirmed) {
      const { name, dob } = result.value;
      const formattedDob = dob.split("-").reverse().join("/");
      const dataToSend = {
        pan_number: formData.pan_no,
        name,
        dob: formattedDob,
        customer_id: formData.id,
      };

      try {
        // setLoadderPan(true);

        const response = await configServ.verify(dataToSend); // API call

        // ✅ Safely extract the nested match values
        const panMatch = response?.data?.data?.name_as_per_pan_match;
        const dobMatch = response?.data?.data?.date_of_birth_match;

        // ✅ Proceed only if both are true (or 1)
        if (panMatch === true && dobMatch === true) {
          const res = await configServ.markPanVerified(dataToSend); // API call
          if (res.success) {
            setIsChanged(!isChanged);
            setOpenDialog(false);
            clear();
            await Swal.fire(
              "Verified!",
              "PAN card successfully verified.",
              "success"
            );
          }
        } else {
          await Swal.fire(
            "Verification Failed",
            "Your name or date of birth did not match PAN records.",
            "error"
          );
        }
      } catch (e) {
        console.log(e);
        await Swal.fire(
          "Error",
          "Something went wrong during PAN verification.",
          "error"
        );
      } finally {
        // setLoadderPan(false); // Always stop loading
      }
    }
  };

  const [gstType, setGstType] = useState("without_gstin"); // default can be with or without
  const handleGstTypeChange = async (event) => {
    const selectedType = event.target.value;
    setGstType(selectedType);
  
    if (selectedType === "with_gstin") {
      const { value: gstin, isConfirmed, isDismissed } = await Swal.fire({
        title: "Enter GSTIN Number",
        input: "text",
        inputLabel: "GSTIN",
        inputPlaceholder: "Enter GSTIN number",
        confirmButtonText: "Verify",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) return "GSTIN is required!";
          if (
            !/^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1})$/.test(
              value
            )
          ) {
            return "Invalid GSTIN format!";
          }
        },
      });
  
      if (isConfirmed && gstin) {
        verifyGstinFromAPI(gstin);
      }
  
      if (isDismissed) {
        // User clicked "Cancel" or closed the dialog
        setGstType("without_gstin");
      }
    }
  };
  

  const [gstLoader, setGstLoader] = useState(false)

  const verifyGstinFromAPI = async (gstin) => {
    try {
      setGstLoader(true)
      const res = await configServ.verifyGstIn({ gstin: gstin }); // API call

      const data = res.data?.data?.data;

      if (res.data.code === 200 && data?.gstin) {
        const pan_no = data.gstin.slice(2, 12); // PAN is the 3rd to 12th character of GSTIN

        const updatedData = {
          fname: data.lgnm,
          contact_name:data.lgnm,
          address: data.pradr?.addr?.st || "",
          city: data.pradr?.addr?.loc || "",
          State: data.pradr?.addr?.stcd || "",
          Pin: data.pradr?.addr?.pncd || "",
          gstin: data.gstin,
          pan_no: pan_no,
          type: "GST Compliant",
        };

        setFormData((prev) => ({
          ...prev,
          ...updatedData,
        }));

        Swal.fire({
          icon: "success",
          title: "GSTIN Verified",
          text: `Name: ${data.lgnm}`,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Invalid GSTIN",
          text: "No data found or verification failed.",
        });
      }
    } catch (e) {
      console.log(e);
      Swal.fire({
        icon: "error",
        title: "API Error",
        text: "Something went wrong while verifying GSTIN.",
      });
    }finally{
      setGstLoader(false)
    }
  };

  const clear = () => {
    setFormData(initialFormData);
    setEditData(null);
    setIsDone(false);
    setIsEdit(false);
    setValidationErrors({});
    setGstType("without_gstin")
  };

  //#endregion

  return (
    <>
      <AlertDialog
        open={dialogOpen}
        setOpen={handleCloseDialog}
        title={title}
        message={dialogContent}
        buttonTitle="Ok"
        buttonType={buttonType}
      />
      <BulkCustomerUploadDialog
        open={openn}
        handleClose={() => setOpen(false)}
      />

      <LoaderBackdrop open={loadderPan || gstLoader} />

      <CustomerContact
        handleClose={handleCustContactClose}
        open={openCustContact}
        customer_id={formData.id}
        customer_code={formData.customer_code}
      />

      {/* <motion.h4 style={{ textAlign: 'center' }}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1 }}
            >
                Add Category
            </motion.h4>
            <br /> */}

      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"CUSTOMERS"}
        handlePopup={handleClickOpen}
        create={openDialog}
        showCreate={Boolean(is_super || is_admin || permissions?.includes(19))}
      />

      {openDialog && (
        <motion.div
          style={{
            width: "100%",
            backgroundColor: "#e3f3fc",
            marginTop: 0,
            padding: 20,
            borderRadius: "10px",
            border: "none",
          }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.1, delay: 0.1 }}
        >
          <Grid
            container
            alignItems="flex-end"
            justifyContent="flex-start"
            spacing={1}
          >
            <Grid container alignItems="center" justifyContent="space-between">
              <Typography sx={{ fontSize: "16px", fontWeight: "bolder" }}>
                Personal Details
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={gstType === "with_gstin"}
                    onChange={(e) =>
                      handleGstTypeChange({
                        target: {
                          value: e.target.checked
                            ? "with_gstin"
                            : "without_gstin",
                        },
                      })
                    }
                  />
                }
                label="I have a GSTIN"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <TextField
                fullWidth
                size="small"
                label={
                  <span>
                    Firm Name<span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="fname"
                onChange={handleChange}
                value={formData.fname || ""}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {isCustomerName || isEdit ? (
                        <CheckCircleIcon color="success" />
                      ) : (
                        <CancelIcon color="error" />
                      )}
                    </InputAdornment>
                  ),
                }}
                error={!!validationErrors.fname}
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <TextField
                fullWidth
                size="small"
                label={
                  <span>
                    Contact Name<span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="contact_name"
                onChange={handleChange}
                onClick={() => {
                  setIsDone(true);
                  assignContactName();
                }}
                value={formData.contact_name || ""}
                error={!!validationErrors.contact_name}
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <TextField
                fullWidth
                size="small"
                label={
                  <span>
                    Mobile Number
                    {/* <span style={{ color: 'red' }}>*</span> */}
                  </span>
                }
                name="mobile"
                type="number"
                onChange={handleChange}
                value={formData.mobile || ""}
                // error={!!validationErrors.mobile}
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <TextField
                fullWidth
                size="small"
                label={<span>Email</span>}
                name="email"
                onChange={handleChange}
                value={formData.email || ""}
                error={!!validationErrors.email}
                sx={{ backgroundColor: "white" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{ color: "red" }}>
                      {validationErrors.email}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <TextField
                fullWidth
                size="small"
                label={
                  <span>
                    Bill To Address<span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="address"
                onChange={handleChange}
                value={formData.address || ""}
                error={!!validationErrors.address}
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <FormControl fullWidth size="small">
                <InputLabel error={!!validationErrors.country}>
                  Country<span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  required
                  name="country"
                  label="Country"
                  value={formData.country || ""}
                  onChange={handleChange}
                  error={!!validationErrors.country}
                  sx={{ backgroundColor: "white" }}
                >
                  {countryList.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item.country}>
                        {item.country}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <FormControl fullWidth size="small">
                <InputLabel error={!!validationErrors.State}>
                  State<span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  required
                  name="State"
                  label="State"
                  value={formData.State || ""}
                  onChange={handleChange}
                  error={!!validationErrors.State}
                  sx={{ backgroundColor: "white" }}
                >
                  {stateList.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item.State}>
                        {item.State}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <TextField
                fullWidth
                type="number"
                size="small"
                label={<span>Pin</span>}
                name="Pin"
                onChange={handleChange}
                value={formData.Pin || ""}
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                type="text"
                size="small"
                label={<span>City</span>}
                name="city"
                onChange={handleChange}
                value={formData.city || ""}
                sx={{ backgroundColor: "white" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <LocationOnIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => SetRunLocation((prev) => !prev)}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <TextField
                type="date"
                label="Date of Birth"
                variant="outlined"
                fullWidth
                size="small"
                name="date_of_birth"
                value={formData.date_of_birth || ""}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <FormControl fullWidth size="small">
                <InputLabel id="customer-type">
                  Customer Type<span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  labelId="customer-type"
                  label="Customer Type"
                  name="type"
                  value={formData.type || ""}
                  onChange={handleChange}
                  error={!!validationErrors.type}
                  sx={{ backgroundColor: "white" }}
                >
                  {Constants.customerTypes.map((item, index) => (
                    <MenuItem key={index} value={item.value}>
                      {item.label}{" "}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Divider variant="middle" flexItem sx={{ my: 1 }} />

          <Grid
            container
            alignItems="flex-end"
            justifyContent="flex-start"
            spacing={1}
          >
            <Grid item xs={12} md={12} justifyContent={"flex-start"}>
              <Typography sx={{ fontSize: "16px", fontWeight: "bolder" }}>
                Account Details
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <TextField
                fullWidth
                type="number"
                size="small"
                label={
                  <span>
                    Opening Amount<span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="openingamount"
                onChange={handleChange}
                value={formData.openingamount || ""}
                defaultValue={0}
                error={!!validationErrors.openingamount}
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size="small"
                label="PAN/NO"
                name="pan_no"
                onChange={handleChange}
                value={formData.pan_no || ""}
                error={!!validationErrors.pan_no}
                helperText={
                  validationErrors.pan_no === "Invalid PAN number format"
                    ? "Invalid PAN number format"
                    : ""
                }
                sx={{ backgroundColor: "white" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {isEdit && formData.pan_no?.length === 10 ? (
                        formData.is_pan_verified ? (
                          <CheckCircleIcon color="success" />
                        ) : (
                          <CancelIcon
                            color="error"
                            onClick={handlePanVerified}
                            style={{ cursor: "pointer" }}
                          />
                        )
                      ) : null}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <TextField
                fullWidth
                size="small"
                label="GSTIN/UIN"
                name="gstin"
                onChange={handleChange}
                value={formData.gstin || ""}
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <FormControlLabel
                control={<Checkbox />}
                name="is_credit_days"
                checked={Boolean(formData.is_credit_days)}
                onChange={handleChangeCheckbox}
                label="Check credit days"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <TextField
                fullWidth
                label="Credit Period"
                size="small"
                type="number"
                name="credit_period"
                InputProps={{
                  endAdornment: "d",
                }}
                disabled={
                  Boolean(formData.is_credit_days) === true ? false : true
                }
                onChange={handleChange}
                value={formData.credit_period || ""}
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <TextField
                fullWidth
                label="Credit Limit"
                size="small"
                type="number"
                name="credit_limit"
                disabled={
                  Boolean(formData.is_credit_days) === true ? false : true
                }
                onChange={handleChange}
                value={formData.credit_limit || ""}
                sx={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
              <FormControlLabel
                control={<Checkbox />}
                name="status"
                checked={Boolean(formData.status)}
                onChange={handleChangeCheckbox}
                label="Status"
                sx={{ fontWeight: "bold" }}
              />
              <FormControlLabel
                control={<Checkbox />}
                name="send_mail"
                checked={Boolean(formData.send_mail)}
                onChange={handleChangeCheckbox}
                label="Send Mail"
                sx={{ fontWeight: "bold" }}
              />
            </Grid>

            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="flex-end"
            >
              {/* Add Other Contacts button */}
              {isEdit && (
                <Grid item>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleCustContactOpen}
                    startIcon={<ContactsIcon />}
                  >
                    Add Other Contacts
                  </Button>
                </Grid>
              )}

              {/* Cut or Reset button */}
              <Grid item>
                {isEdit ? (
                  <IconButton
                    onClick={handleCut}
                    sx={{
                      borderRadius: 2,
                      px: 2,
                      py: 1,
                      backgroundColor: "red",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "darkred",
                      },
                      boxShadow: 2,
                      transition: "all 0.3s ease",
                    }}
                    title="cut"
                  >
                    <CancelIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                ) : (
                  <Button
                    onClick={clear}
                    variant="contained"
                    color="secondary"
                    startIcon={<RotateLeftIcon />}
                  >
                    Reset
                  </Button>
                )}
              </Grid>

              {/* Save / Update button */}
              <Grid item>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  color={isEdit ? "success" : "primary"}
                  startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
                >
                  {isEdit ? "Update" : "Save"}
                </Button>
              </Grid>

              {/* Bulk button */}
              <Grid item>
                <Button
                  onClick={handleBulkUpload}
                  variant="contained"
                  color="success"
                  startIcon={<CloudUploadIcon />}
                >
                  Bulk
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </motion.div>
      )}
    </>
  );
};

export default memo(CustomerCard);
